// extracted by mini-css-extract-plugin
export var brand = "_bn-9";
export var compact = "_bn-6";
export var extraSmall = "_bn-7";
export var icon = "_bn-0";
export var large = "_bn-4";
export var light = "_bn-1";
export var medium = "_bn-5";
export var outline = "_bn-b";
export var primaryDark = "_bn-a";
export var primaryLight = "_bn-8";
export var primaryModern = "_bn-c";
export var success = "_bn-2";
export var successSolid = "_bn-3";